import * as types from './types';

export const showSnackbar = (payload) => ({ type: types.SHOW_SNACKBAR, payload });
export const hideSnackbar = () => ({ type: types.HIDE_SNACKBAR });

export const showDialog = (payload) => ({ type: types.SHOW_DIALOG, payload });
export const hideDialog = () => ({ type: types.HIDE_DIALOG });
